import React from 'react';
import VBox from '../../components/layout/VBox';
import Cabecalho from '../../components/tipografia/Cabecalho';
import Texto from '../../components/tipografia/Texto';
import Markdown from '../chat/Markdown';
import styles from './page.module.css';

const TermosUsoPage = () => {
    return (
        <VBox style={{ padding: '2rem', maxWidth: '1200px', margin: '0 auto' }}>
            <Markdown className={styles.container} value={`        
# TERMOS DE USO – TERACHAT

**Última atualização:** 18/12/2025

Estes Termos de Uso regulam o acesso e a utilização da plataforma **Terachat**, disponibilizada pela **Tera Sistemas** ("Terachat", "nós"), por pessoas jurídicas ("Cliente", "você").

Ao criar uma conta, acessar ou utilizar a plataforma, o Cliente declara que leu, entendeu e concorda integralmente com estes Termos.

---

## 1. Objeto

A Terachat oferece uma plataforma no modelo **Software as a Service (SaaS)** para atendimento digital, automação de comunicação, chatbots (inclusive com IA), CRM, relatórios e integrações com canais e serviços de terceiros.

O presente instrumento concede ao Cliente uma **licença de uso não exclusiva, intransferível e revogável**, enquanto vigente a relação contratual.

---

## 2. Natureza do Serviço (SaaS)

2.1. A Terachat não vende software nem transfere qualquer direito de propriedade intelectual ao Cliente.

2.2. A plataforma é acessada via internet, hospedada em infraestrutura própria ou de terceiros contratados pela Terachat.

2.3. Atualizações, melhorias e alterações podem ser realizadas continuamente, desde que não comprometam de forma relevante a prestação do serviço.

---

## 3. Cadastro e Acesso

3.1. O uso da plataforma é restrito a pessoas jurídicas, mediante cadastro realizado por representante autorizado.

3.2. O Cliente é responsável:
- Pela veracidade das informações fornecidas;
- Pela guarda das credenciais de acesso;
- Por toda atividade realizada em sua conta.

3.3. A Terachat não se responsabiliza por acessos indevidos decorrentes de falha do Cliente na proteção de seus dados.

---

## 4. Integrações e Serviços de Terceiros

4.1. A plataforma integra-se a serviços de terceiros, como WhatsApp (Meta), operadoras, gateways de pagamento, provedores de IA e outros.

4.2. O Cliente reconhece que:
- A contratação, ativação e manutenção desses serviços são de sua exclusiva responsabilidade;
- Regras, políticas, limitações, bloqueios, suspensões ou cobranças impostas por terceiros não são controladas pela Terachat.

4.3. A Terachat não se responsabiliza por reprovações, bloqueios, falhas, custos ou alterações impostas por serviços de terceiros.

---

## 5. Planos, Valores e Cobrança

5.1. Os valores e critérios de cobrança seguem a proposta comercial aceita ou as condições vigentes na plataforma.

5.2. O Cliente reconhece que determinados custos são variáveis, incluindo, mas não se limitando a:
- Notificações;
- Mensagens;
- Uso de recursos de IA;
- Serviços de terceiros.

5.3. A inadimplência poderá resultar na suspensão ou cancelamento do acesso à plataforma.

---

## 6. Uso Adequado da Plataforma

6.1. É vedado ao Cliente:
- Utilizar a plataforma para fins ilícitos;
- Enviar conteúdos que violem leis, direitos de terceiros ou políticas dos canais integrados;
- Tentar acessar código-fonte, realizar engenharia reversa ou explorar falhas de segurança.

6.2. O Cliente é integralmente responsável pelo conteúdo enviado a seus clientes finais.

---

## 7. Propriedade Intelectual

7.1. Todos os direitos sobre a plataforma, incluindo código-fonte, arquitetura, fluxos, modelos, relatórios, marcas e IA, pertencem exclusivamente à Terachat.

7.2. Nenhuma disposição destes Termos concede ao Cliente qualquer direito de propriedade intelectual.

---

## 8. Disponibilidade e Suporte

8.1. A Terachat emprega esforços razoáveis para manter a plataforma disponível, podendo ocorrer interrupções para manutenção, atualizações ou fatores externos.

8.2. O suporte técnico é prestado conforme plano contratado.

---

## 9. Limitação de Responsabilidade

9.1. A Terachat não será responsável por lucros cessantes, perda de faturamento ou danos indiretos.

9.2. Eventual responsabilidade da Terachat fica limitada ao valor pago pelo Cliente nos últimos **12 (doze) meses** anteriores ao evento.

---

## 10. Suspensão e Encerramento

10.1. A Terachat poderá suspender ou encerrar o acesso do Cliente em caso de violação destes Termos, uso indevido ou inadimplência.

10.2. O encerramento não exime o Cliente de obrigações financeiras pendentes.

---

## 11. Plano Gratuito (Free Tier)

11.1. A Terachat poderá disponibilizar ao Cliente um plano gratuito (“Free Tier”), que permite o uso da plataforma em ambiente de produção, de forma limitada e sem custo.

11.2. O uso do Free Tier está sujeito a restrições técnicas, operacionais e funcionais, definidas a critério exclusivo da Terachat, podendo incluir, entre outras:
- Limites de usuários, canais, mensagens ou recursos;
- Restrições de funcionalidades;
- Limitação de capacidade ou desempenho.

11.3. O Cliente reconhece e concorda que, no Free Tier:
- Não há garantia de disponibilidade da plataforma;
- Não há SLA (Acordo de Nível de Serviço);
- Não há suporte técnico dedicado ou atendimento prioritário;
- A Terachat não se obriga a manter o serviço ativo ou disponível de forma contínua.

11.4. A Terachat poderá, a qualquer momento e sem aviso prévio:
- Alterar as regras, limites ou funcionalidades do Free Tier;
- Suspender ou encerrar o acesso ao Free Tier;
- Exigir a migração para um plano pago para continuidade do uso.

11.5. O uso do Free Tier ocorre por conta e risco do Cliente, não sendo a Terachat responsável por perdas de dados, indisponibilidade do serviço ou quaisquer prejuízos decorrentes de sua utilização.

11.6. A utilização do Free Tier não gera qualquer obrigação comercial, contratual ou financeira entre as partes, além do aceite destes Termos de Uso.

---

## 12. Foro

Fica eleito o foro da comarca de **Goiânia/GO**, com renúncia a qualquer outro, por mais privilegiado que seja.
`} />
        </VBox>
    );
};

export default TermosUsoPage;
